import { NumberField } from "@justhome/react-ui";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useController } from "react-hook-form";
import useFormStep from "../../lib/useFormStep";
import FormStep from "../FormStep";

const MonthlyNetIncomeStep: FC = () => {
  const { t } = useTranslation();
  const { form, handleSubmit, handleBack } = useFormStep({
    next: "contact",
  });

  const {
    control,
    formState: { errors },
  } = form;

  const { field } = useController({
    name: "monthlyNetIncome",
    control,
    rules: {
      required: {
        value: true,
        message: t("monthlyNetIncome.required"),
      },
    },
  });

  return (
    <FormStep
      onBack={handleBack}
      onSubmit={handleSubmit}
      title={t("monthlyNetIncome.title")}
      description={t("monthlyNetIncome.description")}
    >
      <NumberField
        {...field}
        autoFocus
        suffix="€"
        errorMessage={errors.monthlyNetIncome?.message}
        label={t("monthlyNetIncome.label")}
        placeholder={t("monthlyNetIncome.placeholder")}
        data-testid="monthlyNetIncome"
      />
    </FormStep>
  );
};

export default MonthlyNetIncomeStep;
